// Generated by CoffeeScript 2.7.0
/* eslint-disable */

(function () {
  var base;

  window.Lanalytics || (window.Lanalytics = {});

  (base = window.Lanalytics).Model || (base.Model = {});

  window.Lanalytics.Model.StmtUser = class StmtUser extends (
    window.Lanalytics.Model.StmtResource
  ) {
    constructor(uuid) {
      super('user', uuid);
    }
  };

  window.Lanalytics.Model.AnonymousUser = class AnonymousUser extends (
    window.Lanalytics.Model.StmtUser
  ) {
    constructor() {
      super('user', 'ANONYMOUS');
    }
  };
}).call(this);
